module.exports = __webpack_public_path__ + "img/not-data.5885bacd.png";